import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useLocation } from "react-router";
import { Spinner } from "@/shared/ui";
import { useSession } from "../model/useSession";

/**
 * Route guard. While the session is being restored from the refresh cookie it shows a spinner;
 * anonymous visitors are sent to /login and come back here afterwards.
 */
export function RequireAuth() {
  const { t } = useTranslation();
  const { status } = useSession();
  const location = useLocation();

  if (status === "unknown") {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner label={t("loading")} />
      </div>
    );
  }
  if (status === "anonymous") {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <Outlet />;
}
